import React from "react";

const ReferralShareBtn = ({ sharingLink, text, icon, onClick }) => {
  return (
    <span className="refer-sharing-item">
      <button
        onClick={() => {
          onClick ? onClick() : window.open(sharingLink, "_blank");
        }}
        className="refer-sharing-item-btn"
      >
        <div className="refer-sharing-item-btn-icon-container">{icon}</div>
        <div className="refer-sharing-item-btn-text">{text}</div>
      </button>
    </span>
  );
};

export default ReferralShareBtn;
